import { cn } from '@/lib/cn';

const sizes = { sm: 'size-4 border-2', md: 'size-6 border-2', lg: 'size-10 border-4' } as const;

export function Spinner({
  size = 'md',
  label = 'Loading',
  className,
}: {
  size?: keyof typeof sizes;
  label?: string;
  className?: string;
}) {
  return (
    <span role="status" aria-label={label} className={cn('inline-flex', className)}>
      <span
        aria-hidden
        className={cn(
          'inline-block animate-spin rounded-full border-current border-t-transparent',
          sizes[size],
        )}
      />
    </span>
  );
}

/** Centered spinner for page/section loading. */
export function PageSpinner({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="flex min-h-48 items-center justify-center text-fg-subtle">
      <Spinner size="lg" label={label} />
    </div>
  );
}
